import InputMask from 'react-input-mask';
// form
import { Controller, useFormContext } from 'react-hook-form';

import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

interface IProps {
  name: string;
  mask: string;
}

export default function RHFMaskField({ name, mask, ...other }: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, onChange, value, ...field }, fieldState: { error } }) => (
        // @ts-ignore
        <InputMask
          maskChar=""
          mask={mask}
          value={value ? String(value).toUpperCase() : ''}
          onChange={(event) => {
            const nextValue = event.target.value ? event.target.value.toUpperCase() : '';
            onChange(nextValue);
          }}
          {...field}
        >
          {
            // @ts-ignore
            (inputProps: TextFieldProps) => (
              <TextField
                error={!!error}
                ref={ref}
                helperText={error?.message}
                {...inputProps}
                fullWidth
                {...other}
              />
            )
          }
        </InputMask>
      )}
    />
  );
}
